<!--
 * @Author: zjw
 * @Date: 2021-06-03 15:03:17
 * @LastEditTime: 2023-03-31 14:17:23
 * @FilePath: \web-app\src\components\content\myDialogDetail.vue
 * @Environment: Vue + Element
 * @Description: 详情组件(函数式组件)
-->
<template functional>
    <div v-bind="data.attrs" v-on="listeners">
        <el-dialog
            :title="$options.getTitle()"
            :width="props.dialogWidth || '30%'"
            :visible="props.isDialogDetailShow"
            @close="props.closeDialog"
        >
            <el-form
                ref="operForm"
                label-width="80px"
                :model="props.operForm"
                label-position="left"
            >
                <el-form-item
                    v-for="(item, index) in props.operFormArr"
                    :key="index"
                    :label="item.label"
                    :prop="item.name"
                >
                    <el-input
                        size="small"
                        v-model="props.operForm[item.name]"
                        :type="item.type || 'text'"
                        readonly
                        autosize
                    ></el-input>
                </el-form-item>
            </el-form>
            <slot></slot>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "myDialogDetail",
    inheritAttrs: false, //不会将props外的属性添加到子组件的dom节点上
    render(createElement, context) {
        console.log(createElement);
        console.log(context);
    },
    getTitle() {
        return "详情";
    },
};
</script>




